import { appStore } from "@src/stores/AppStore";
import { required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";

export class FormClient {
  name = new FieldState("").validators(required);
  photo = new FieldState<File | null>(null);
  workspace_company_id = new FieldState(
    appStore.workspaceStore.defaultWorkspaceCompany?.id ?? "",
  ).validators(required);

  form = new FormState([this.name, this.photo, this.workspace_company_id]);

  serialize() {
    return {
      name: this.name.$,
      photo: this.photo.$,
      workspace_company_id: this.workspace_company_id.$,
    };
  }
}
